import styled from "styled-components";
import { useState, useEffect } from "react";

import VerticalDivider from "./VerticalDivider";
import HorizontalDivider from "./HorizontalDivider";
import NavButton from "./NavButton";
import { FaBars } from "react-icons/fa"

const NavBackground = styled.div`
    background-color: rgb(10,10,10);
    width: 100%;
    height: 5vh;
    position: fixed;
    display: flex;
    flex-direction: row;
    padding-left: 30px;
    align-items: center;

    @media (max-width: 768px) {
        justify-content: space-between;
        padding: 0 20px;
    }

    z-index: 5;
`

const DesktopNav = styled.div`
    height: 5vh;
    display: flex;
    flex-direction: row;
    align-items: center;

    @media (max-width: 768px) {
        display: none;
    }
`;

const MenuButton = styled.button`
    background: none;
    border: none;
    color: ${(props) => (props.open ? "rgb(95, 99, 214)" : "white")};
    font-size: 1.5rem;
    display: none;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    
    @media (max-width: 768px) {
        display: block;
    }
`;

const Menu = styled.div`
    visibility: hidden;
    flex-direction: row;
    align-items: center;
    
    @media (max-width: 768px) {
        overflow: hidden;
        flex-direction: column;
        position: absolute;
        top: 5vh;
        left: 0;
        width: 100%;
        background-color: rgb(10, 10, 10);
        padding: 0 0 0 25px;

        max-height: ${(props) => (props.open ? "40vh" : "0")};
        visibility: ${(props) => (props.open ? "visible" : "hidden")};
        transition: max-height 0.5s ease-in-out, visibility 0.5s ease-in-out;
    }
`;

function NavBar({setActivePage}){
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setMenuOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return(
        <NavBackground>
            <DesktopNav>
                <NavButton text="HOME" setActivePage={setActivePage}/>
                <VerticalDivider/>
                <NavButton text="ABOUT ME" setActivePage={setActivePage}/>
                <VerticalDivider/>
                <NavButton text="CODING" setActivePage={setActivePage}/>
                <VerticalDivider/>
                <NavButton text="MUSIC" setActivePage={setActivePage}/>
            </DesktopNav>
            <MenuButton onClick={() => setMenuOpen(!menuOpen)} open={menuOpen}>
                <FaBars />
            </MenuButton>
            <Menu open={menuOpen}>
                <NavButton text="HOME" setActivePage={setActivePage} setMenuOpen={setMenuOpen}/>
                <HorizontalDivider/>
                <NavButton text="ABOUT ME" setActivePage={setActivePage} setMenuOpen={setMenuOpen}/>
                <HorizontalDivider/>
                <NavButton text="CODING" setActivePage={setActivePage} setMenuOpen={setMenuOpen}/>
                <HorizontalDivider/>
                <NavButton text="MUSIC" setActivePage={setActivePage} setMenuOpen={setMenuOpen}/>
            </Menu>
        </NavBackground>
    )
}

export default NavBar;